<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Liste des modules</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="data" :options="options">
          <div slot="action" slot-scope="props">
            <b-button type="button" @click.prevent="destroy(props.row.id)" class="badge badge-danger mr-3 p-2"><i
              class="fa fa-remove"></i> Supprimer
            </b-button>
            <b-button type="button" @click="editModule(props.row.id)" class="badge badge-primary p-2">
              <i class="fa fa-edit"></i> Modifier
            </b-button>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer">
        <b-button type="button" @click="addModule" class="pull-right" size="md" variant="primary">
          <i class="fa fa-plus"></i> Ajouter un module
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "GestionModule",
    data() {
      return {
        columns: ['nom', 'ordre', 'espace.nom', 'description', 'action'],
        data: [],
        options: {
          headings: {
            'espace.nom': 'Espace',
          },
          sortable: ['nom', 'espace.nom'],
          filterable: ['nom', 'espace.nom'],
          perPage: 10,
          perPageValues: [10, 25, 50],
          texts: {
            filterPlaceholder: "Nom"
          },
          orderBy: {column: 'ordre', ascending: false}
        }
      }
    },
    mounted() {
      this.all();
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      all() {
        this.$axios
          .get("/administration/modules")
          .then(response => {
            this.data = response.data.modules
          })
          .catch(() => {
            this.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Un probléme est survenue, merci de contacter l\'administrateur',
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
      destroy(id) {
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: "Voulez-vous vraiment supprimer ce module ?",
            type: 'warning',
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor: "#ff1744",
            confirmButtonText: 'Annuler',
            cancelButtonText: 'Supprimer',
          })
          .then((result) => {
            if (!result.value) {
              this.$store.commit('IS_LOADING', true)
              this.$axios
                .post("/administration/modules/delete/" + id)
                .then(() => {
                  this.$store.commit('IS_LOADING', false)
                  this.$swal({
                    position: 'top',
                    type: 'success',
                    title: 'Suppression avec succès',
                    text: "L'espace a bien été supprimé",
                    showConfirmButton: false,
                    timer: 5000
                  })
                  this.all()
                })
                .catch(() => {
                  self.$store.commit('IS_LOADING', false)
                  self.$swal({
                    position: 'top',
                    type: 'warning',
                    title: 'Attention !!',
                    text: 'Un problème est survenu, merci de contacter un administrateur',
                    showConfirmButton: false,
                    timer: 5000
                  })
                })
            }
          })

      },
      addModule() {
        this.$router.push({path: '/administration/modules/add'})
      },
      editModule(id) {
        this.$router.push({path: '/administration/modules/edit/' + id})
      }
    }
  }
</script>
